import 'ui-core/components/tabs/js/tabs.js';

// @TODO: remove the preselectTab after the fix on the generic level is released.

(function (UX) {
    var tab = UX.tab;
    tab.preselectTab = function () {
        // The preselectTab function should be cleanup
        // Its better to use query string in url instead session storage for select active tab
        // We should depend on data-target always instead of href because href may contain url not tab-pane selector
        // selection of active tab should tested on nested tabs and multi tabs on page

        $('.tab').each(function () {
            //the rest of this code doesnt seem to support multiple tabs on the page.. but this does
            const _this = $(this);

            if (_this.data('js-preselect') === false)
                //If you don't need js to select the active tab
                return true;

            const $activeTab = _this.find('.tab__nav').find('li.active a');
            let activeTab = tab.getPaneTarget($activeTab);
            let sessionActiveTab = null;

            if (!activeTab && sessionStorage.activeTab) {
                // check "sessionStorage.activeTab" is solution for LIT-189292
                activeTab = sessionStorage.getItem('activeTab');
                sessionActiveTab = activeTab;
            }

            // Checking if activeTab contains hash, if not it is not 'tab'
            const hash = activeTab ? activeTab.match(/#/) : null;
            if (activeTab && (!hash || hash.index !== 0)) return;

            if (_this.find(activeTab).length === 0) {
                activeTab = null;
            } else if (sessionActiveTab) {
                sessionStorage.setItem('activeTab', '');
            }

            if (location.search !== '') {
                const reExp = /activeTab=\b[\w-]+$/g;

                if (reExp.test(location.search)) {
                    const activeParameter = location.search.match(reExp)[0];
                    if ($('#' + activeParameter.split('=')[1]).length) {
                        activeTab = '#' + activeParameter.split('=')[1];
                    }
                }
            }

            let $firstItem = _this.find('.tab__nav').find('li:first-of-type a');
            if (!activeTab) activeTab = tab.getPaneTarget($firstItem);

            if ((activeTab && activeTab.split('#').length < 2) || activeTab === '') return true;

            const triggerTarget = $("[data-target='" + activeTab + "'], [href='" + activeTab + "']");

            if (!triggerTarget.closest('.w-slide__btn').length) {
                triggerTarget.click();
                _this.find(activeTab).addClass('active'); // in some cases to display tab content the .active class has to tiggered. Known case: alerts management in profile, when directed to a specific tab.
            }
        });
    };
})(UX);
